/* KrakenTheMeta dashboard — core: the brewing screen and the router.
 * Helpers, toasts, sheets and menus come from the shared UI kit (lib/ui.js), card + Scryfall helpers
 * from lib/cards.js, the card sheet from lib/cardsheet.js. Modules are bundled in filename order by
 * tools/build-php.cjs (esbuild) into assets/js/dash.js.
 */
import "../lib/ui.js";
import "../lib/cards.js";
import "../lib/cardsheet.js";

(function () {
  "use strict";

  var KD = window.KD;

  // ---------------------------------------------------------------- the brewing screen
  // A generation takes 60–120 s and the server doesn't stream progress, so the stages advance
  // on a clock that matches the pipeline's real shape: search, then the long build, then checks.
  KD.brew = (function () {
    var timer = null, t0 = 0, el = null, run = null;
    var STAGES = [
      ["sonar", "Reading the live meta", "The Kraken writes its own searches and reads what's winning now."],
      ["build", "Building the whole list", "Every card, counted line by line, with a real mana base."],
      ["shield", "Checking every card", "Matched on Scryfall. Legality, singleton and colors enforced."]
    ];
    // 2026-10-03: a run can bring its own stages and timings (the deck upgrade uses this screen too)
    function stageFor(sec) {
      var at = run.at;
      for (var i = at.length - 1; i >= 0; i--) if (sec >= at[i]) return Math.min(i + 1, run.stages.length - 1);
      return 0;
    }
    function paint() {
      var sec = Math.floor((Date.now() - t0) / 1000);
      var s = stageFor(sec);
      KD.$$(".brew__stage", el).forEach(function (row, i) {
        row.classList.toggle("is-done", i < s);
        row.classList.toggle("is-live", i === s);
        KD.$(".dot", row).innerHTML = KD.icon(i < s ? "check" : run.stages[i][0]);
      });
      var mm = Math.floor(sec / 60), ss = ("0" + (sec % 60)).slice(-2);
      KD.$(".brew__time", el).textContent = mm + ":" + ss + (sec > run.longAfter ? " · " + run.longNote : "");
    }
    return {
      start: function (o) {
        el = KD.$("#brew");
        var size = o.size || 100;
        run = { stages: o.stages || STAGES, at: o.at || [14, 62], longAfter: o.longAfter || 140, longNote: o.longNote || "big lists take a little longer" };
        el.innerHTML = '<div class="brew__card" role="status" aria-live="polite">' +
          '<div class="brew__sonar"><i></i><i></i><i></i><svg viewBox="0 0 64 64" aria-hidden="true"><use href="#mark"/></svg></div>' +
          '<p class="depth-tag">' + KD.esc(o.format || "") + " · " + size + " cards</p>" +
          (o.title || "<h2>The Kraken is <em>diving.</em></h2>") +
          (o.prompt ? '<p class="brew__prompt">“' + KD.esc(o.prompt) + "”</p>" : "") +
          '<div class="brew__stages">' + run.stages.map(function (st) {
            return '<div class="brew__stage"><span class="dot"></span><div><b>' + st[1] + "</b><small>" + st[2] + "</small></div></div>";
          }).join("") + "</div>" +
          '<p class="brew__time mono">0:00</p>' +
          '<p class="brew__note">' + (o.note || "Usually one to two minutes. Keep this tab open; you can switch tabs meanwhile.") + "</p>" +
          (o.promo ? '<div class="brew__promo">' +
            '<video muted loop playsinline preload="none" poster="' + KD.SITE + '/downloads/ktm-assistant-demo-poster.jpg"><source src="' + KD.SITE + '/downloads/ktm-assistant-demo.mp4" type="video/mp4"></video>' +
            '<div><p class="depth-tag">While your deck brews</p><h4>Meet the Kraken Assistant</h4><p>A free deck tracker and AI coach for MTG Arena, with every match recapped on your profile.</p>' +
            '<a class="btn btn--ghost btn--sm" href="' + KD.SITE + '/arena-assistant" target="_blank" rel="noopener">See the app' + KD.icon("external") + "</a></div></div>" : "") +
          "</div>";
        el.hidden = false;
        document.body.style.overflow = "hidden";
        t0 = Date.now();
        paint();
        timer = setInterval(paint, 1000);
        var v = KD.$("video", el);
        if (v) try { v.play().catch(function () {}); } catch (e) { /* autoplay blocked */ }
      },
      stop: function () {
        clearInterval(timer);
        if (!el) return;
        var v = KD.$("video", el);
        if (v) { try { v.pause(); } catch (e) { /* ignore */ } }
        el.hidden = true;
        el.innerHTML = "";
        document.body.style.overflow = "";
      }
    };
  })();

  // ---------------------------------------------------------------- router
  // #/home  #/decks  #/deck/<id>  #/collection  #/arena  #/profile
  // Old deep links (#decks, #profile, …) from the rest of the site still land in the right place.
  KD.routes = {};
  KD.go = function (path) {
    var h = "#/" + path.replace(/^#?\/?/, "");
    if (location.hash === h) KD.router(); else location.hash = h;
  };
  KD.parseRoute = function () {
    var h = (location.hash || "").replace(/^#\/?/, "");
    if (!h) return { name: "home", arg: null };
    var parts = h.split("/");
    var name = parts[0], arg = parts[1] ? decodeURIComponent(parts[1]) : null;
    if (!KD.routes[name]) name = "home";
    return { name: name, arg: arg };
  };
  var TITLES = { home: "Home", decks: "Decks", deck: "Deck", collection: "Collection", arena: "Arena", profile: "Profile" };
  var NAV = { home: "home", decks: "decks", deck: "decks", collection: "collection", arena: "arena", profile: "profile" };
  KD.setTitle = function (t) {
    var h = KD.$("[data-title]");
    if (h) h.textContent = t;
    document.title = t + " · KrakenTheMeta";
  };
  KD.router = function () {
    if (!KD.state || !KD.state.user) return;
    var r = KD.parseRoute();
    KD.$$("[data-nav]").forEach(function (a) { a.classList.toggle("is-active", a.dataset.nav === NAV[r.name]); a.toggleAttribute("aria-current", a.dataset.nav === NAV[r.name]); });
    KD.setTitle(TITLES[r.name] || "Home");
    var view = KD.$("#view");
    view.classList.remove("is-entering");
    void view.offsetWidth;
    view.classList.add("is-entering");
    KD.closeSheets();
    window.scrollTo(0, 0);
    try { KD.routes[r.name](view, r.arg); }
    catch (e) {
      console.error("route", r.name, e);
      view.innerHTML = '<div class="empty">' + KD.icon("alert") + "<h3>Something went wrong</h3><p>" + KD.esc(e && e.message || "") + '</p><a class="btn btn--ghost" href="#/home">Back home</a></div>';
    }
  };
  window.addEventListener("hashchange", function () { KD.router(); });
})();
